// Shared client-side timing logic for system notifications / nudges.
// Mirrors the backend helpers in server.py so the UI hides prompts that the
// admin has scheduled outside their active window or during quiet hours.
// All calculations are done in IST (Asia/Kolkata, UTC+5:30) to match the server.

function istParts() {
  const now = new Date();
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
  const ist = new Date(utcMs + 5.5 * 3600000);
  return { hour: ist.getHours(), weekday: (ist.getDay() + 6) % 7 }; // Monday = 0
}

function within(sh, eh, hour) {
  if (sh === eh) return true;
  if (sh < eh) return sh <= hour && hour < eh;
  return hour >= sh || hour < eh; // wraps past midnight (e.g. 22 -> 6)
}

export function quietNow(sm) {
  const q = (sm || {}).quiet_hours || {};
  if (!q.enabled) return false;
  const { hour } = istParts();
  return within(Number(q.start_hour ?? 22), Number(q.end_hour ?? 6), hour);
}

export function timingOk(m) {
  if (!m) return true;
  const { hour, weekday } = istParts();
  const sh = Number(m.start_hour ?? 0);
  let eh = m.end_hour;
  if (eh === undefined || eh === null || eh === "") eh = 24;
  eh = Number(eh);
  if (!within(sh, eh, hour)) return false;
  const freq = m.frequency || "daily";
  if (freq === "weekdays" && weekday >= 5) return false;
  if (freq === "weekly" && weekday !== Number(m.weekday || 0)) return false;
  return true;
}

// Global quiet hours + this message's own active window.
export function notifAllowed(sm, key) {
  if (quietNow(sm)) return false;
  return timingOk((sm || {})[key]);
}
